import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './auth';
import locationReducer from './location';
import disciplineReducer from './discipline';
import activeSelectionReducer from './activeSelection';
import mapDataReducer from './mapData';
import searchReducer from './search';
import searchFiltersReducer from './searchFilters';
const rootReducer = combineReducers({
  auth: authReducer,
  location: locationReducer,
  search: searchReducer,
  discipline: disciplineReducer,
  activeSelection: activeSelectionReducer,
  mapData: mapDataReducer,
  searchFilters: searchFiltersReducer,
});

export default rootReducer;
